//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Hidden",1,0],[0,"IntegerQuantity",1,0],[0,"Layer",1,0],[0,"LayerOption",1,0],[0,"NonGeometric",1,0],[0,"QuantityType",1,0],[0,"RealQuantity",1,0],[0,"ReferenceComponent",1,0],[1,"SelectedObjects",0,"Assemblies.SelectComponentList",0],[0,"SpecificColor",1,0],[0,"SpecificLineFont",1,0],[0,"SpecificPartialShade",1,0],[0,"SpecificTranslucency",1,0],[0,"SpecificWidth",1,0]],[[[],"SynchronizeLayers",{},0,0],[[],"SynchronizeDisplay",{},0,0],[[],"SynchronizeAttributes",{},0,0]],[]];
SPLM.Assemblies.AssembliesGeneralPropertiesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.AssembliesGeneralPropertiesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.AssembliesGeneralPropertiesBuilder.HiddenOptions = Object.freeze({
    "No" : "No", "Yes" : "Yes", "Mixed" : "Mixed"});

SPLM.Assemblies.AssembliesGeneralPropertiesBuilder.LayerOptions = Object.freeze({
    "OriginalLayer" : "OriginalLayer", "SpecifiedLayer" : "SpecifiedLayer", "Mixed" : "Mixed"});

SPLM.Assemblies.AssembliesGeneralPropertiesBuilder.ReferenceComponentOptions = Object.freeze({
    "No" : "No", "Yes" : "Yes", "Mixed" : "Mixed"});

SPLM.Assemblies.AssembliesGeneralPropertiesBuilder.QuantityOptions = Object.freeze({
    "Number" : "Number", "AsRequired" : "AsRequired", "Mixed" : "Mixed"});

export default SPLM;